




import { Vue, Component, Watch } from 'vue-property-decorator';
import TuiGrid from 'tui-grid';
import { Getter } from 'vuex-class';
import store from '@/store';
import { setNoDataMessage } from '@/helpers/grid';
import '@/assets/css/godo/utils.css';
import { SHOPBY_ACCESSTOKEN, SHOPBY_REFRESHTOKEN, SESSION_INITIALIZE, AUTH_TOKEN_REFRESHED } from '@/const/cookie';
import { deleteCookie, getCookie } from '@/utils/cookie';
import { setToken } from '@/utils/token';

@Component
export default class App extends Vue {
  @Getter('lnb/isLnbShowing') isLnbShowing!: boolean;

  private unloadGuard = (event: BeforeUnloadEvent) => {
    const hasUnsavedForm = store.getters['hasUnsavedForm'] && this.$route.meta && this.$route.meta.detection;

    if (!hasUnsavedForm) return;
    event.preventDefault();
    event.returnValue = '';
  };

  created() {
    if (!getCookie(SESSION_INITIALIZE)) {
      deleteCookie(SHOPBY_ACCESSTOKEN);
      deleteCookie(SHOPBY_REFRESHTOKEN);
      deleteCookie('adminInfo');
    }
    this.onLnbShowingChanged();
    this.initGridSetting();
  }

  mounted() {
    window.$i18n = this.$i18n;
    window.$t = this.$t;

    window.addEventListener('beforeunload', this.unloadGuard);

    // message 이벤트 리스너 추가
    window.addEventListener('message', this.handleReceiveMessage);
  }

  destroyed() {
    window.removeEventListener('beforeunload', this.unloadGuard);

    // 컴포넌트 제거 시 이벤트 리스너 해제
    window.removeEventListener('message', this.handleReceiveMessage);
  }

  // 최상단 부모에서 store 변경을 감지하여 처리
  @Watch('isLnbShowing')
  onLnbShowingChanged() {
    if (this.isLnbShowing) {
      document.body.classList.remove('min');
    } else {
      document.body.classList.add('min');
    }
  }

  private handleReceiveMessage(e: MessageEvent) {
    // AUTH_TOKEN_REFRESHED 메시지 처리
    if (e.data?.type === AUTH_TOKEN_REFRESHED) {
      const { accessToken, refreshToken, autoLogoutMin } = e.data.data ?? {};

      if (accessToken && refreshToken) {
        setToken(accessToken, refreshToken, autoLogoutMin);
      }
    }
  }

  private initGridSetting(): void {
    setNoDataMessage(this.$t('NO_RESULT').toString());

    TuiGrid.applyTheme('clean', {
      outline: {
        border: '#ddd',
        showVerticalBorder: false,
      },
      area: {
        body: {
          background: '#fff',
        },
      },
      cell: {
        normal: {
          background: '#fff',
          border: '#eee',
          showVerticalBorder: true,
          showHorizontalBorder: true,
          text: '#333',
        },
        header: {
          background: '#fafbfc',
          border: '#eee',
          text: '#333',
        },
        selectedHeader: {
          background: '#fafbfc',
          text: '#333',
        },
      },
    });
  }
}
